<template>
  <v-dialog
    v-model="showPasswordResetDialog"
    ref="dialog"
    hide-overlay
    max-width="500px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
  >
    <v-card>
      <v-card-title class="primary white--text">
        <h3 class="headline mb-0">{{ $t('texts.resetPassword') }}</h3>
        <v-spacer/>
        <v-btn text small fab @click="showPasswordResetDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <v-container class="pa-0" fluid>
            <v-text-field
              :label="$t('texts.email')"
              v-model="form.email"
              required
              v-validate="'required|email'"
              :error-messages="errors.collect('email')"
              data-vv-name="email"
              :data-vv-as="$t('texts.email')"
            />
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="secondary"
          text
          @click="showUserLoginDialog()"
        >
          {{ $t('texts.back') }}
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="validateBeforeSubmit()"
          :disabled="sendPasswordResetMailPending"
          :loading="sendPasswordResetMailPending"
        >
          {{ $t('texts.resetPassword') }}
          <v-icon right class="white--text">check_circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');

export default {
  name: 'UserPasswordResetDialog',
  data() {
    return {
      showPasswordResetDialog: false,
      form: {
        email: '',
      },
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  mounted() {
    this.$eventBus.$on('show-user-password-reset-dialog', () => {
      this.showPasswordResetDialog = true;
    });
  },
  computed: {
    ...mapUserState([
      'sendPasswordResetMailPending',
    ]),
  },
  methods: {
    ...mapUserActions([
      'sendPasswordResetMail',
    ]),
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendPasswordResetMail(this.form).then((response) => {
            this.showPasswordResetDialog = false;
          });
        }
      });
    },
    showUserLoginDialog() {
      this.showPasswordResetDialog = false;
      this.$eventBus.$emit('show-user-login-dialog');
    },
  },
};
</script>
